/*
 * @Author: 鱿鱼须 1519964028@qq.com
 * @Date: 2024-07-25 17:20:01
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2024-07-27 00:22:39
 * @FilePath: \dc.amin\src\api\login
 */
import http from '@/http/axios_init'

// 登录
export function apiLogin(data) {
	return http({
		method: 'POST',
		url: 'admin/v1/login',
		data
	})
}

// 获取密码盐
export function apiSalt(phone) {
	return http({
		method: 'POST',
		url: `admin/v1/login/get_salt?work_no=${phone}`
	})
}
// 获取菜单
export function apiMenuList(phone) {
	return http({
		method: 'POST',
		url: 'admin/v1/get_menus'
	})
}

// 获取验证码
export function apiSecurityCode() {
	return http({
		method: 'POST',
		url: 'admin/v1/login/get_code'
	})
}

// 获取使用手册地址
export function get_operating_manual_url() {
	return http({
		method: 'POST',
		url: 'get_operating_manual_url'
	})
}

//清除缓存
export function onClearCache() {
	return http({
		method: 'POST',
		url: 'admin/v1/login/clear'
	})
}

//其余接口
export function set_cache() {
	return http({
		method: 'POST',
		url: 'admin/v1/login/set_cache'
	})
}


//其余接口
export function get_account_status() {
	return http({
		method: 'POST',
		url: 'admin/v1/public/emp/get_account_status'
	})
}